import { useRef, useState } from 'react'
import { useUpdateTermsAndConditions } from './TermsAndConditions.hooks'
import { errorNotify } from 'utils/toster'
import { useAuthContext } from 'hooks/auth'
import Button from 'components/Button'
import { signOut } from 'utils/common'

const TermsAndCondition = ({ onClose }: { onClose: () => void }) => {
	const {
		context: { profile },
	} = useAuthContext()
	const scrollContainerRef = useRef<HTMLDivElement | null>(null)

	const { mutateAsync: create, isLoading } = useUpdateTermsAndConditions({ id: profile?.id })
	const [isButtonEnabled, setIsButtonEnabled] = useState(false)

	const handleScroll = () => {
		const container: any = scrollContainerRef.current
		if (container) {
			const containerRect = container.getBoundingClientRect()
			const containerHeight = containerRect.height + 2
			const scrollPosition = container?.scrollHeight - container?.scrollTop
			if (scrollPosition <= containerHeight) {
				setIsButtonEnabled(true)
			}
		}
	}
	const handleAcceptButton = async () => {
		try {
			await create({
				isTermAndConditionAccepted: true,
			})
			localStorage.setItem('termsAndConditions', 'true')
			window.dispatchEvent(new Event('storage'))
			onClose()
		} catch (err) {
			localStorage.setItem('termsAndConditions', 'false')
			window.dispatchEvent(new Event('storage'))
			errorNotify(err as string)
		}
	}

	const handleDecline = async () => {
		await signOut()
		onClose()
	}
	const disableButton = isLoading || !isButtonEnabled
	return (
		<div className="sm:min-h-screen bg-gray-100 p-4">
			<div>
				<h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">
					CareHalo Terms of Use
				</h2>
				<div
					ref={scrollContainerRef}
					className="sm:max-h-[550px] max-h-[calc(100dvh-170px)] overflow-y-auto scrollbar-thin scrollbar-thumb-fountainBlue scrollbar-track-gray-200"
					onScroll={handleScroll}
				>
					<div className="border p-4 rounded-md bg-gray-50  overflow-y-auto">
						<div className="text-md">These Terms were last updated on August, 2019</div>

						<div className="p-2">
							<div className="text-base font-semibold mt-2 ">Agreement to Terms of Use</div>
							<p className="sm:text-lg text-base font-normal">
								The following Terms of Use (“Terms” or “Agreement”) govern your access to and use of
								CareHalo Corporation and our affiliated medical groups, including CareHalo Alamabama
								LLC, CareHalo West LLC, CareHalo Ohio LLC (together, “CareHalo”) websites, mobile
								applications, and all other services we provide (hereinafter the “Services”). Please
								read the Terms carefully. Your use of the Services constitutes your agreement to be
								bound by all terms. If you disagree with one or more of these terms or find them
								unacceptable in any way, please do not use the Services. This Agreement is divided
								into two parts. Part One explains all of the terms that govern your use of the
								Services. Part Two contains additional legal terms, including provisions that limit
								our liability to you and require individual arbitration for any potential legal
								dispute. To use the Services, you must accept all of the terms of this Agreement.
							</p>
							<div className="text-base font-semibold mt-2">Changes to Terms of Use</div>
							<p className="sm:text-lg text-base font-normal">
								The following Terms of Use (“Terms” or “Agreement”) govern your access to and use of
								CareHalo Corporation and our affiliated medical groups, including CareHalo Alamabama
								LLC, CareHalo West LLC, CareHalo Ohio LLC (together, “CareHalo”) websites, mobile
								applications, and all other services we provide (hereinafter the “Services”). Please
								read the Terms carefully. Your use of the Services constitutes your agreement to be
								bound by all terms. If you disagree with one or more of these terms or find them
								unacceptable in any way, please do not use the Services. This Agreement is divided
								into two parts. Part One explains all of the terms that govern your use of the
								Services. Part Two contains additional legal terms, including provisions that limit
								our liability to you and require individual arbitration for any potential legal
								dispute. To use the Services, you must accept all of the terms of this Agreement.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Part One: Terms Governing Use of the Site and Services
							</div>
							<p className="sm:text-lg text-base font-normal">
								The following Terms of Use (“Terms” or “Agreement”) govern your access to and use of
								CareHalo Corporation and our affiliated medical groups, including CareHalo Alamabama
								LLC, CareHalo West LLC, CareHalo Ohio LLC (together, “CareHalo”) websites, mobile
								applications, and all other services we provide (hereinafter the “Services”). Please
								read the Terms carefully. Your use of the Services constitutes your agreement to be
								bound by all terms. If you disagree with one or more of these terms or find them
								unacceptable in any way, please do not use the Services. This Agreement is divided
								into two parts. Part One explains all of the terms that govern your use of the
								Services. Part Two contains additional legal terms, including provisions that limit
								our liability to you and require individual arbitration for any potential legal
								dispute. To use the Services, you must accept all of the terms of this Agreement.
							</p>
							<div className="text-lg font-bold mt-2">Age Limitations</div>
							<p className="sm:text-lg text-base font-normal">
								This Site and the Services are intended and only suitable for individuals 18 years
								of age and above..
							</p>
							<div className="text-lg font-bold mt-2">Restricted</div>
							<p className="sm:text-lg text-base font-normal">
								You may use this Site only to the extent that you obey all laws, rules, and
								regulations applicable to your use of this Site.
							</p>
							<div className="text-lg font-bold mt-2">Your Privacy</div>
							<p className="sm:text-lg text-base font-normal">
								Upon acceptance of these Terms you confirm that you have read, understood, and
								accepted CareHalo’s Online Privacy Policy and Notice of Privacy Practices, as
								applicable.
							</p>
							<div className="text-lg font-bold mt-2">Registration</div>
							<p className="sm:text-lg text-base font-normal">
								Registration is not required to view certain content on the Site. However, to use
								some parts of the Site and Services you may be required to register and provide
								certain information about yourself, including your e-mail address and password
								(“Credentials”). If you become a registered member of the Site, you accept
								responsibility for all activities that occur under your registration account. You
								agree to provide true, accurate, complete, and correct information at the time of
								registration, and to promptly update this information as needed so that it remains
								true, accurate, complete, and correct. You should keep your Credentials private and
								not share your Credentials with anyone else. You are responsible for maintaining the
								confidentiality of your Credentials. If you believe someone has accessed the Site
								using your Credentials without your authorization, e-mail us immediately at
								help@carehalo.com.
							</p>
							<div className="text-lg font-bold mt-2">Transactions</div>
							<p className="sm:text-lg text-base font-normal">
								If you wish to purchase products or services described or linked to on the Site
								(each such purchase, a “Transaction”), CareHalo or the third party provider of the
								product or service will request certain information from you that is applicable to
								your Transaction, including, without limitation, credit card and other payment and
								shipping information. You understand that, if any such information is provided to
								CareHalo, then CareHalo shall treat any such information in the manner described in
								our Privacy Policy. By supplying such information, you grant CareHalo the right to
								provide such information to third parties for purposes of facilitating the
								completion of Transactions initiated by you or on your behalf. You agree to pay all
								charges incurred by you or any users of your membership account or credit card (or
								other applicable payment mechanism) at the price(s) in effect when such charges are
								incurred, including, without limitation, all shipping and handling charges. You
								shall also be responsible for paying any applicable taxes relating to your
								purchases. YOU REPRESENT AND WARRANT THAT YOU HAVE THE LEGAL RIGHT TO USE ANY CREDIT
								CARD(S) OR OTHER PAYMENT MECHANISM USED IN CONNECTION WITH ANY TRANSACTION.
								Descriptions or images of, or references to, products or services on the Site do not
								imply CareHalo’s endorsement of such products or services. We reserve the right,
								without prior notification, to change such descriptions or references, to limit the
								order quantity on any product or service and/or to refuse service to you.
								Verification of information applicable to a purchase may be required prior to
								CareHalo’s acceptance of any order. Price and availability of any product or service
								are subject to change without notice. CareHalo is not responsible for errors in the
								prices or descriptions of any product or service. Refunds and exchanges shall be
								subject to CareHalo’s and/or any applicable third party’s refund and exchange
								policies in effect at the time of the applicable Transaction. Current rates for any
								product or service available through the Site may be obtained by sending an email to
								help@carehalo.com.
							</p>
							<div className="text-lg font-bold mt-2">Consent to Electronic Communications</div>
							<p className="sm:text-lg text-base font-normal">
								You agree to receive email communications from CareHalo and request online access to
								your profile to do things such as make or cancel appointments. You grant permission
								for CareHalo to send you SMS text messages and emails regarding, vital monitoring,
								CareHalo provided devices, your vital alerts, medication reminders, personal health
								questions, sign up, wait times, my appointments, follow up questions, billing
								questions and attempts to collect payment should the need arise. You grant and state
								your preference to have all staff at CareHalo communicate with you by email or
								standard SMS messaging regarding various aspects of my medical care, which may
								include, but shall not be limited to, vital recordings, depression screenings,
								telemedicine visits, test results, prescriptions, appointments, patient satisfaction
								surveys and billing. You understand that email and standard SMS messaging are not
								confidential methods of communication and may be insecure. You further understand
								that, because of this, there is a risk that email and standard SMS messaging
								regarding your medical care might be intercepted and read by a third party.
								<ol className="list-decimal">
									<li>
										When you opt-in to the service, we will send you an SMS message to confirm your
										signup.
									</li>
									<li>
										You can cancel the SMS service at any time. Just text "STOP" to us. After you
										send the SMS message "STOP" to us, we will send you an SMS message to confirm
										that you have been unsubscribed. After this, you will no longer receive SMS
										messages from us.
									</li>
									<li>
										If at any time you forget what keywords are supported, just text "HELP" to us.
										After you send the SMS message "HELP" to us, we will respond with instructions
										on how to use our service as well as how to unsubscribe.
									</li>
									<li>
										We are able to deliver messages to major mobile phone carriers by using a third
										party service provider. Please note that Carriers are not liable for delayed or
										undelivered messages
									</li>
									<li>
										As always, message and data rates may apply for any messages sent to you from us
										and to us from you. Message frequency varies. If you have any questions about
										your text plan or data plan, it is best to contact your wireless provider. For
										all questions about the services provided by this short code, you can send an
										email to help@CareHalo.com.
									</li>
									<li>
										If you have any questions regarding privacy, please click this link to our
										privacy policy.
									</li>
								</ol>
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Social Media and Online Communities
							</div>
							<p className="sm:text-lg text-base font-normal">
								CareHalo may provide you opportunities to share information on third party social
								media sites or platforms such as Facebook, Instagram, LinkedIn, Twitter, Google+,
								YouTube or other similar sites (collectively, “Social Media Sites”). CareHalo may
								also provide you opportunities to participate in online communities on such Social
								Media Sites and may host discussion boards, chats, and other forums on this Site.
								For example, you may use your Instagram handle and tag your photos and postings
								(“Tagged Content”) with hashtags that we may provide from time to time in order to
								submit your Tagged Content for potential use on our Site. If you post Tagged Content
								with hashtags as we may provide from time to time, your activity and participation
								is governed by these Terms. Additionally, you remain responsible for your compliance
								with other applicable terms and conditions such as those of Instagram or other
								Social Media Sites. Without limitation of any other obligations, you agree that you
								will be respectful of others and their privacy and will not submit photos of others
								without their express permission. If you participate in CareHalo online community,
								discussion board or other forum, you agree that anything you submit is being
								provided by you voluntarily, on a nonconfidential basis, and without any
								compensation due to you and you grant CareHalo a perpetual, worldwide, royalty-free,
								transferable, and sub-licensable, right and license to use, copy, distribute,
								modify, create joint and derivative works, your content, postings and Tagged Content
								in any form or format. You further agree that (a) you will not post, transmit, or
								link to any material, websites, Tagged Content or other information or content that
								is libelous, defamatory, false, obscene, indecent, lewd, violent, abusive,
								threatening, harassing, discriminatory, or an expression of political or hate
								speech; (b) you may only post, upload or transmit photos or materials for which you
								have the copyright or other permission to distribute electronically citing the
								original source; (c) you may not violate, plagiarize, or infringe on the rights of
								third parties, including copyright, trademark, trade secret, privacy, personal,
								publicity, moral or proprietary rights; (d) you agree that any Tagged Content or
								materials you post or upload will be owned by you or be in the public domain; (e)
								you may not intentionally post, create, upload or transmit any software or other
								material that contains a virus or other harmful code or device; (f) you may not
								solicit other users, or distribute advertising, for products or services through the
								Site, distribute chain letters or messages, mass mailings or bulk email or other
								bulk messages, or gather email addresses for the purpose of sending bulk email or
								other messages to other users of the Site; (g) if you choose to submit Tagged
								Content or post items in public or “chat” portions of the Site, such material,
								information, photographs, and other information you post in these public or group
								areas is available to the other individuals using this Site and CareHalo does not
								warrant, guarantee or otherwise take steps to prevent other users from copying,
								displaying, uploading, transmitting or otherwise using your material, information,
								photographs or other information for any purpose whatsoever; (h) you will always use
								caution in posting personally identifying information, and never exchange personal
								financial information, address, phone numbers or other personal information; (i) you
								will not post any material that violates any law or regulation; (j) you will not
								impersonate any other person or use the identity of some other living person; and
								(k) your postings will truthfully reflect your own experience. CareHalo may
								terminate or restrict your access to any CareHalo online community, including access
								through the Site.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Selection and Removal of Tagged Content
							</div>
							<p className="sm:text-lg text-base font-normal">
								CareHalo will review Tagged Content and select certain Tagged Content for posting on
								our Site; we make no guarantee that your Tagged Content will be posted.
								Notwithstanding the foregoing, you remain fully responsible and liable for your
								Tagged Content and its compliance with these Terms, other applicable terms of use
								and applicable laws. If your Tagged Content is posted to our Site, you may request
								removal of your Tagged Content by marking it as “private” in your Social Media Site
								account or by emailing us at help@CareHalo.com.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Monitoring</div>
							<p className="sm:text-lg text-base font-normal">
								We have no obligation to monitor any related websites, chats, discussion boards or
								any other materials that you or third parties transmit or post on or to the Site or
								related websites, if any. However, you acknowledge and agree that we have the right
								(but not the obligation) to monitor the Site, discussion boards, the chats, and the
								materials you transmit or post; to alter or remove any such materials (including,
								without limitation, any posting to a chat or discussion board); and to disclose such
								materials and the circumstances surrounding their transmission to any third party in
								order to operate the Site properly, to protect ourselves, our sponsors, and our
								other clients and visitors, and to comply with legal obligations or governmental
								requests.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Copyright Notice</div>
							<p className="sm:text-lg text-base font-normal">
								This Site is owned and operated by CareHalo Corporation. The entire contents and
								design of the site are protected by U.S. and international copyright law. All rights
								regarding the Site and materials contained on the Site are either owned by CareHalo,
								are licensed to it, or are used with permission. CareHalo and its licensors retain
								and reserve all proprietary rights to the contents of this Site.
								<br />
								<br />
								You may not copy, republish, upload, post, display, transmit, or frame any of these
								materials without prior written consent from CareHalo. You may link to, view,
								download, use, display and print a single copy of the materials found on this Site
								only for personal, noncommercial, and informational purposes as long as: (1) you do
								not alter or modify the materials in any way; (2) you include all applicable
								copyright, trademark and other notices and disclaimers; and (3) you do not use the
								materials in a way that suggests an association with CareHalo or an affiliated
								entity. All such copies must include, at a minimum, the following copyright notice:
								“Copyright © [current year] CareHalo All rights reserved.” Any other use of the Site
								or the information contained here is strictly prohibited. CareHalo may terminate the
								above license at any time for any reason. If you breach any of these terms your
								license terminates immediately and automatically and without notice. Upon the
								termination of this license you must stop using this site, including all content,
								and return or destroy all copies, including electronic copies, of the content in
								your possession or control.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Copyright Infringement – DMCA Notice
							</div>
							<p className="sm:text-lg text-base font-normal">
								The Digital Millennium Copyright Act (the “DMCA”) provides remedies for copyright
								holders who believe in good faith that material appearing on the Internet infringes
								their rights under copyright law. If you believe in good faith that content or
								material on this Site infringes a valid copyright owned by you, you (or your agent)
								may send CareHalo a notice requesting that the material be removed, or access to it
								blocked. This request should be sent to: help@carehalo.com; or to: CareHalo, PO Box
								1157, Woodstock, GA 30188.
								<br />
								<br />
								The notice must include the following information: (a) a physical or electronic
								signature of a person authorized to act on behalf of the owner of an exclusive right
								that is allegedly infringed; (b) identification of the copyrighted work claimed to
								have been infringed; (c) identification of the material that is claimed to be
								infringing or the subject of infringing activity; (d) the name, address, telephone
								number, and email address of the complaining party; (e) a statement that the
								complaining party has a good faith belief that use of the material in the manner
								complained of is not authorized by the copyright owner, its agent or the law; and
								(f) a statement that the information in the notification is accurate and, under
								penalty of perjury, that the complaining party is authorized to act on behalf of the
								owner of an exclusive right that is allegedly infringed. If you believe in good
								faith that a notice of copyright infringement has been wrongly filed against you,
								the DMCA permits you to send us a counter-notice. Notices and counter-notices must
								meet the then-current statutory requirements imposed by the DMCA. Notices and
								counter-notices with respect to the Site should be sent to the address above.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Trademark Notice</div>
							<p className="sm:text-lg text-base font-normal">
								CareHalo names and logos and all related product and service names, design marks,
								and slogans are the trademarks or service marks of CareHalo. All rights are
								reserved. You are not authorized to use any CareHalo name or mark in any
								advertisement, publicity or in any other commercial manner without prior written
								consent of CareHalo. All other trademarks appearing on the Site are the property of
								their respective owners.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Security</div>
							<p className="sm:text-lg text-base font-normal">
								We have implemented technical and organizational measures designed to secure your
								personal information from accidental loss and from unauthorized access, use,
								alteration or disclosure. However, we cannot guarantee that unauthorized third
								parties will never be able to defeat those measures or use your personal information
								for improper purposes. You acknowledge that you provide your personal information at
								your own risk.
								<br />
								Part Two: Additional Legal Terms
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Representation and Warranties
							</div>
							<p className="sm:text-lg text-base font-normal">
								You represent and warrant to us that: (a) you are at least eighteen (18) years of
								age; and (b) your use of this Site will be in compliance with these Terms.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">No Warranties</div>
							<p className="sm:text-lg text-base font-normal">
								USE OF THIS SITE IS AT YOUR OWN RISK. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE
								LAW, THE SITE AND ALL CAREHALO APPLICATIONS, WEB PLATFORMS AND SERVICES ARE PROVIDED
								WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT
								LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
								OR NON-INFRINGEMENT. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY
								YOU FROM CAREHALO OR THROUGH THIS SITE WILL CREATE ANY WARRANTY NOT EXPRESSLY STATED
								HEREIN. WITHOUT LIMITING THE FOREGOING, CAREHALO, ITS PROCESSORS, ITS PROVIDERS, ITS
								LICENSORS (AND THEIR RESPECTIVE SUBSIDIARIES, AFFILIATES, AGENTS, DIRECTORS, AND
								EMPLOYEES) DO NOT WARRANT THAT THE CONTENT IS ACCURATE, RELIABLE OR CORRECT; THAT
								THIS SITE WILL MEET YOUR REQUIREMENTS; THAT THIS SITE WILL BE AVAILABLE AT ANY
								PARTICULAR TIME OR LOCATION, UNINTERRUPTED OR SECURE; THAT ANY DEFECTS OR ERRORS
								WILL BE CORRECTED; OR THAT THIS SITE IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
								ANY CONTENT DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE OF THIS SITE IS
								DOWNLOADED AT YOUR OWN RISK AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO
								YOUR PROPERTY OR LOSS OF DATA THAT RESULTS FROM SUCH DOWNLOAD. CAREHALO DOES NOT
								WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE
								ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THIS SITE OR ANY HYPERLINKED WEBSITE
								OR SERVICE, OR FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND CAREHALO WILL NOT BE
								A PARTY TO OR IN ANY WAY MONITOR ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY
								PROVIDERS OF PRODUCTS OR SERVICES.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Indemnity</div>
							<p className="sm:text-lg text-base font-normal">
								BY VISITING THIS SITE AND/OR CAREHALO MOBILE APPLICATION, YOU AGREE TO INDEMNIFY,
								DEFEND, AND HOLD HARMLESS CAREHALO, AND ANY AFFILIATED CAREHALO ENTITY, ITS
								OFFICERS, DIRECTORS, EMPLOYEES, CONTRACTORS, AGENTS, AND REPRESENTATIVES
								(COLLECTIVELY “CAREHALO PARTIES”) FROM AND AGAINST ALL CLAIMS, ACTIONS, DEMANDS,
								LIABILITIES, JUDGMENTS, SETTLEMENTS, COSTS, LOSSES, DAMAGES, TAX ASSESSMENTS,
								PENALTIES, INTEREST AND EXPENSES (INCLUDING, WITHOUT LIMITATION, REASONABLE
								ATTORNEYS’ FEES) ARISING OUT OF ANY DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL,
								SPECIAL, EXEMPLARY, PUNITIVE OR ANY OTHER CLAIM YOU MAY INCUR IN CONNECTION WITH
								YOUR USE OF THIS SITE, INCLUDING, WITHOUT LIMITATION, ANY CLAIMS FOR DEFAMATION,
								VIOLATION OF PUBLICITY OR PRIVACY, COPYRIGHT OR TRADEMARK INFRINGEMENT RESULTING
								FROM YOUR SUBMISSIONS OF ANY CONTENT, TAGGED CONTENT OR OTHER MATERIALS, ANY
								ECONOMIC HARM, LOST PROFITS, DAMAGES TO BUSINESS, DATA OR COMPUTER SYSTEMS, OR ANY
								DAMAGES RESULTING FROM RELIANCE ON ANY CONTENT OR RESULTING FROM ANY INTERRUPTIONS,
								WORK STOPPAGES, COMPUTER FAILURES, DELETION OF FILES, ERRORS, OMISSIONS,
								INACCURACIES, DEFECTS, VIRUSES, DELAYS OR MISTAKES OF ANY KIND, EVEN IF YOU HAVE
								PREVIOUSLY ADVISED CAREHALO OF THE POSSIBILITY OF SUCH CLAIM.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Limitation of Liability and Damages
							</div>
							<p className="sm:text-lg text-base font-normal">
								THE USER’S SOLE REMEDY FOR DISSATISFACTION WITH THE SITE AND/OR MOBILE APPLICATION
								ANY OF ITS SERVICE IS TO STOP USING THE SITE OR SERVICE. YOU AGREE THAT UNDER NO
								CIRCUMSTANCE SHALL ANY OF CAREHALO PARTIES BE LIABLE FOR ANY DAMAGE RESULTING FROM
								YOUR USE OR INABILITY TO USE THIS SITE OR THE MATERIALS ON THIS SITE. THIS
								PROTECTION COVERS CLAIMS BASED ON WARRANTY, CONTRACT, TORT, STRICT LIABILITY, AND
								ANY OTHER LEGAL THEORY. THIS PROTECTION COVERS ALL LOSSES AND CLAIMS OF ANY TYPE
								INCLUDING, WITHOUT LIMITATION, DIRECT OR INDIRECT, SPECIAL, INCIDENTAL, RELIANCE,
								CONSEQUENTIAL, EXEMPLARY, AND PUNITIVE DAMAGES, PERSONAL INJURY/WRONGFUL DEATH, LOST
								PROFITS, OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS INTERRUPTION. Disputes If a
								dispute of any kind arises, we want to understand and address your concerns quickly
								and to your satisfaction. Please contact help@carehalo.com with any dispute. If we
								cannot resolve your concerns, we agree to an informal and inexpensive dispute
								resolution process requiring individual arbitration. “Disputes” between you and
								CareHalo, including its processors, suppliers or licensors or their respective
								affiliates, agents, directors or employees, are defined for the purposes of these
								Terms to include any claim, controversy, or dispute (whether involving ontract,
								tort, equitable, statutory, or any other legal theory) between you and CareHalo
								including, but not limited to, any claims relating in any way to these Terms
								(including its breach, termination, or interpretation), any other aspect of our
								relationship, CareHalo advertising, and any use of CareHalo services.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Binding Individual Arbitration
							</div>
							<p className="sm:text-lg text-base font-normal">
								You and CareHalo agree to arbitrate all Disputes. Arbitration is more informal than
								a lawsuit in court and seeks to resolve disputes more quickly. Instead of a judge or
								a jury, the case will be decided by a neutral arbitrator who has the power to award
								the same damages and relief that a court can. ANY ARBITRATION UNDER THIS AGREEMENT
								WILL BE ONLY BE ON A INDIVIDUAL BASIS; CLASS ARBITRATIONS, CLASS ACTIONS, PRIVATE
								ATTORNEY GENERAL ACTIONS, AND CONSOLIDATION WITH OTHER ARBITRATIONS ARE NOT
								PERMITTED, AND YOU ARE WAIVING YOUR RIGHTS TO HAVE YOUR CASE DECIDED BY A JURY AND
								TO PARTICIPATE IN A CLASS ACTION AGAINST CAREHALO. If any provision of this
								arbitration agreement is found unenforceable, the unenforceable provision shall be
								severed, and the remaining arbitration terms shall be enforced (but in no case shall
								there be a class arbitration). All Disputes shall be resolved finally and
								exclusively by binding individual arbitration with a single arbitrator administered
								by ADR Services, Inc. according to this provision and the applicable arbitration
								rules for that forum. Consumer claimants (individuals whose transaction is intended
								for personal, family, or household use) may elect to pursue their claims in their
								local small-claims court rather than through arbitration. The Federal Arbitration
								Act, 9 U.S.C. §§ 1-16, fully applies. If you are a consumer bringing a claim
								relating to personal, household, or family use, any arbitration hearing will occur
								within the county or parish where you reside. Otherwise, any arbitration hearing
								will occur in Atlanta, Georgia, or another mutually agreeable location, or a
								location ordered by the arbitrator. The arbitrator’s award shall be binding on the
								parties and may be entered as a judgment in any court of competent jurisdiction. If
								you prevail on any claim for which you are legally entitled to attorney’s fees, you
								may recover those fees from the arbitrator. For any claim where you are seeking
								relief, CareHalo will not seek to have you pay its attorney’s fees, even if fees
								might otherwise be awarded, unless the arbitrator determines that your claim was
								frivolous. For purposes of this arbitration provision, references to you and
								CareHalo also include respective subsidiaries, affiliates, agents, employees,
								predecessors, successors, and assigns. Subject to and without waiver of the
								arbitration provisions above, you agree that any judicial proceedings (other than
								small claims actions in consumer cases) will be brought in and you hereby consent to
								the exclusive jurisdiction and venue in the state courts in Atlanta, Georgia, or
								federal court for Georgia.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Jurisdiction</div>
							<p className="sm:text-lg text-base font-normal">
								Information provided on CareHalo’s Site and/or mobile application is not targeted to
								users in any particular locality nor is it intended to constitute the doing of
								business in any jurisdiction. This Site is a service provided by CareHalo and does
								not constitute any contact with any jurisdiction outside the State of Georgia. Use
								of this Site is prohibited in any jurisdiction having laws that would void this
								Agreement in whole or essential part or which makes accessing the Site illegal.
								Users in such jurisdictions visit and use this Site entirely at their own risk.
								Note: the essential parts of this Agreement include, without limitation, the
								exclusive venue and exclusive remedy provisions and the warranty disclaimers. This
								Agreement is entered into and performed in the State of Georgia, United States of
								America. It is governed by and shall be construed under the laws of Georgia,
								exclusive of any choice of law or conflict of law provisions.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Requests for Information</div>
							<p className="sm:text-lg text-base font-normal">
								If you contact CareHalo and request information about our programs or services, we
								will use your email or postal address to provide the information you requested. You
								agree that we may use and share information you provide us as described in our
								Online Privacy Policy.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Limitation on Time to Initiate a Dispute
							</div>
							<p className="sm:text-lg text-base font-normal">
								Unless otherwise required by law, an action or proceeding by you relating to any
								Dispute must commence within one year after the cause of action accrues.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Links to Other Websites</div>
							<p className="sm:text-lg text-base font-normal">
								CareHalo’s Site may contain links to third party websites as a convenience to you.
								The inclusion of any website link does imply an approval, endorsement, or
								recommendation by CareHalo. You agree that you access any such website at your own
								risk, and that the site is not governed by the terms and conditions contained in
								these Terms. CareHalo expressly disclaims any liability for these websites. Please
								remember that when you use a link to go from our Site to another website, our
								Privacy Policy is no longer in effect. Your browsing and interaction on any other
								website, including those that have a link on our Site, is subject to that website’s
								own rules and policies.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">
								Downloadable Files and Email
							</div>
							<p className="sm:text-lg text-base font-normal">
								CareHalo cannot and does not guarantee or warrant that email or files available for
								downloading from its Site or Mobile Application will be free of viruses or other
								code that may contaminate or destroy data on your computer. You are responsible for
								implementing sufficient protective procedures and checks to maintain the accuracy of
								your data for maintaining a data back-up or other means for the reconstruction of
								any lost data. CareHalo does not assume any responsibility or risk for damage to
								your computer or its files related to your use of the Services.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Notice for California Users</div>
							<p className="sm:text-lg text-base font-normal">
								If you have a question or complaint regarding the Services provided to you by
								CareHalo please contact us at help@carehalo.com to receive further information
								regarding the Services or to resolve the complaint. You may also contact the
								Complaint Assistance Unit of the Division of Consumer Services of the Department of
								Consumer Affairs by telephone at (800) 952-5210 or TDD (800) 326-2297, or in writing
								at Department of Consumer Affairs, Consumer Information Division, 1625 North Market
								Blvd., Suite N 112, Sacramento, CA 95834.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Other Provisions</div>
							<p className="sm:text-lg text-base font-normal">
								Except as expressly provided in these Terms, these terms are a complete statement of
								the agreement between you and CareHalo, and they describe the entire liability of
								CareHalo and its vendors and suppliers and your exclusive remedy with respect to
								your access and use of this Site. In the event of a conflict between these Terms and
								any other CareHalo agreement or policy, these Terms shall prevail on the subject
								matter of these Terms. If any provision of these Terms is invalid or unenforceable
								under applicable law, then it shall be changed and interpreted to accomplish the
								objectives of such provision to the greatest extent possible under applicable law,
								and the remaining provisions will continue in full force and effect. Headings are
								included for convenience only, and shall not be considered in interpreting these
								Terms. These Terms do not limit any rights that CareHalo may have under trade
								secret, copyright, patent, or other laws. CareHalo’s failure to assert any right or
								provision under these Terms shall not constitute a waiver of such right or
								provision. No waiver of any term of this Agreement shall be deemed a further or
								continuing waiver of such term or any other term.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Assignment</div>
							<p className="sm:text-lg text-base font-normal">
								You may not assign any rights or obligations under this Agreement without CareHalo’s
								prior written consent. CareHalo may assign all or part of this Agreement.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Survival</div>
							<p className="sm:text-lg text-base font-normal">
								All sections of this Agreement which, by their nature are designed to survive
								expiration or termination of this Agreement, including but not limited to indemnity
								and limitation of liability clauses, shall survive.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Waiver</div>
							<p className="sm:text-lg text-base font-normal">
								No waiver of any of these terms shall be deemed a further or continuing waiver of
								such term or condition or any other term or condition.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Notices</div>
							<p className="sm:text-lg text-base font-normal">
								You agree that we may provide any and all notices to you by e-mail, telephone, fax,
								as well as by any other method.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Severability</div>
							<p className="sm:text-lg text-base font-normal">
								If any of the provisions of this Agreement are held unenforceable by a court or
								other tribunal of competent jurisdiction, then those provisions shall be limited or
								eliminated to the minimum extent necessary to allow the remainder of this Agreement
								to retain its full force and effect.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Entire Agreement; Amendment</div>
							<p className="sm:text-lg text-base font-normal">
								This Agreement constitutes the entire agreement between you and CareHalo applicable
								to its subject matter. It may not be modified except as described elsewhere in this
								Agreement.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Conflicting Terms</div>
							<p className="sm:text-lg text-base font-normal">
								Anything on the Site inconsistent or in conflict with the terms of this Agreement is
								superseded by the terms of this Agreement.
							</p>
							<div className="sm:text-xl text-lg font-medium mt-2">Contact Information</div>
							<p className="sm:text-lg text-base font-normal">
								Please contact us with any questions or concerns regarding this Agreement at:
							</p>
							<div className="text-xl font-semibold mt-2">CareHalo</div>
							<p className="sm:text-lg text-base font-normal">
								PO Box 1157, Woodstock, GA 30188 Email: help@carehalo.com.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className="mt-1 flex justify-between gap-3">
				<Button
					className="w-1/4 mt-4 ml-4 py-2 text-white font-semibold rounded-lg transition"
					disabled={disableButton}
					onClick={handleAcceptButton}
					type="primary"
				>
					Accept
				</Button>
				<Button
					className="w-1/4 mt-4 py-2 mr-4 text-white font-semibold rounded-lg transition"
					disabled={disableButton}
					type="default"
					onClick={handleDecline}
				>
					Decline
				</Button>
			</div>
		</div>
	)
}

export default TermsAndCondition
